// Validation rules for passwords based on front-end requirements
import { passwordCase, passwordNumbers } from "helpers/password";
import * as v from "valibot";

import { authResultSchema } from "./auth";

import { rpcContract } from "../rpc";

export const signUpRpcContract = rpcContract({
  name: "signUp" as const,
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
    password: v.pipe(
      v.string(),
      v.minLength(6, "Password must be at least 6 characters"),
      v.maxLength(64, "Password cannot exceed 64 characters"),
      v.regex(passwordNumbers, "Password must contain at least one number"),
      v.regex(passwordCase, "Password must contain both uppercase and lowercase letters"),
    ),
    confirmPassword: v.string(),
  }),
  resultSchema: authResultSchema,
});

export type SignUpParams = v.InferOutput<(typeof signUpRpcContract)["paramsSchema"]>;
export type SignUpResult = v.InferOutput<(typeof signUpRpcContract)["resultSchema"]>;
